module.exports = __webpack_public_path__ + "img/logo.111bb1e9.png";